<script lang="ts">
  const fill: string = 'currentColor'
</script>

<svg width="16" height="8" {fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 8">
  <polygon points="8,3.4 4.7,6.7 11.3,6.7 " />
</svg>
